// extracted by mini-css-extract-plugin
module.exports = {"footerLinks":"footer-links_footerLinks__pRQiT","columnHeader":"footer-links_columnHeader__Wl8FC"};